import { all, put, takeEvery } from 'redux-saga/effects'
import _ from 'lodash'

import { BLOCK_DATA_LOADED } from '../../../../../../../components/Workspace/components/HocBlock/constants'
import { blockSaveCustomData } from '../../../../../../../components/Workspace/components/HocBlock/actions'
import config from '../../../../../../../../../config'

import liensShareTableSaga from './components/Share/components/Table/saga'
import liensDebtorTableSaga from './components/Debtor/components/Table/saga'

function* liensCallSaga(_action) {
    const blockKey = _.get(_action, 'data.blockKey', null)
    if (blockKey !== config.modules.report.blocks.liens.key) return null

    const module = _.get(_action, 'data.module', null)
    const id = _.get(_action, 'data.id', null)
    if (!module || !id || !blockKey) return null

    const data = _.get(_action, 'data.data', [])
    const shareSorted = _.reduce(
        _.get(data, '[2].query.sort.sortedColumns', []),
        (acc, val) => [
            ...acc,
            {
                id: _.get(val, 'columm'), // TYPO FROM BACKEND
                desc: _.get(val, 'direction') === 'desc',
            },
        ],
        []
    )
    const debtorSorted = _.reduce(
        _.get(data, '[3].query.sort.sortedColumns', []),
        (acc, val) => [
            ...acc,
            {
                id: _.get(val, 'columm'), // TYPO FROM BACKEND
                desc: _.get(val, 'direction') === 'desc',
            },
        ],
        []
    )

    yield put(
        blockSaveCustomData(module, id, blockKey, {
            share: {
                table: {
                    data: _.get(data, '[2].rows', []),
                    pagination: _.get(data, '[2].query.pagination', {}),
                    filter: _.get(data, '[2].query.filter', {}),
                    sorted: shareSorted,
                    isLoading: false,
                },
            },
            debtor: {
                table: {
                    data: _.get(data, '[3].data', []),
                    pagination: _.get(data, '[3].query.pagination', {}),
                    filter: _.get(data, '[3].query.filter', {}),
                    sorted: debtorSorted,
                    isLoading: false,
                },
            },
        })
    )

    return null
}

export default function* liensSaga() {
    yield all([takeEvery(BLOCK_DATA_LOADED, liensCallSaga), liensShareTableSaga(), liensDebtorTableSaga()])
}
